import { arrayToSimpleObj } from '../utils';

export const invalidOptions = [
  {
    text: 'High',
    value: '2',
  },
  {
    text: 'Medium',
    value: '1',
  },
  {
    text: 'Low',
    value: '3',
  },
  {
    text: 'Invalid',
    value: '0',
  },
];

export const invalidMap = arrayToSimpleObj(invalidOptions);
